import './CloseIcon.scss'

import React from 'react'
import {style} from '../../../util/style'
import {Icon} from '../../ui/Icon'

const styles = style('closeicon')

export const CloseIcon: React.FC<{
	onClick: () => void
	className?: string
}> = ({onClick, className}) => (
	<a onClick={onClick} className={styles().with(className)}>
		<Icon icon="close" />
	</a>
)
